var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.016 5.01601H18.985V9.98501H17.016V6.98501H14.016V5.01601V5.01601ZM17.016 17.016V14.016H18.985V18.985H14.016V17.016H17.016ZM5.016 9.98401V5.01501H9.985V6.98401H6.985V9.98401H5.016V9.98401ZM6.984 14.016V17.016H9.984V18.985H5.015V14.016H6.984V14.016Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.9109dfda385499bb5967d3e454bbde25.svg";
export { ForwardRef as ReactComponent };